import FaqWeb, { getStaticProps as staticProps } from "./[params]";

/**
 * This file is added, so the faq page will show general tab active on navigating to faq
 * The file can be removed if the faq url is changed with **"frequently-asked-questions/general"**
 * but to match PROD url structure, we've created this file
 */
export default FaqWeb;

export const getStaticProps = staticProps;
